import { Box } from '@chakra-ui/react';
import Button from '@components/interactive/Button';
import Body1 from '@components/typography/Body1';
import { hyphenatePhoneNumber } from '@constants/phoneNumbers';
import CtaWrapper from './CtaWrapper';

function MedicareAdvocate({ phoneNumber }) {
  const hyphenatedPhoneNumber = hyphenatePhoneNumber(phoneNumber);
  const text = `Call ${hyphenatedPhoneNumber}`;

  return (
    <CtaWrapper
      header="Speak with a Licensed Agent"
      renderCta={() => (
        <Box display="flex" flexDirection="column">
          <Body1>Talk to one of our Licensed Medicare Agents today to find the right plans for you.</Body1>
          <Button
            href={`tel:${hyphenatedPhoneNumber}`}
            className="medicare_advocate_call_link"
            size="lg"
            w="100%"
            margin="1rem 0 0 0"
            suppressHydrationWarning // Component depends on Media Query and SSR
          >
            {text}
          </Button>
        </Box>
      )}
    />
  );
}

export default MedicareAdvocate;
